export default __webpack_public_path__ + "static/media/logo-horizontal-white.ae583c5d.svg";